function preventContextMenu(event: Event) {
  event.preventDefault();
  return false;
}

export default {
  bind(el: HTMLElement, binding, vnode) {
    el.addEventListener("contextmenu", preventContextMenu);
    el.classList.add("no-select_no-touch");
  },
  unbind(el: HTMLElement) {
    el.addEventListener("contextmenu", preventContextMenu);
  }
};
